import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { decodeQueryParamData } from 'utils/utils';

function useGetStateFromParams() {
	const params = useParams();
	const location = useLocation();

	const state = useMemo(() => {
		if (params?.id) {
			return decodeQueryParamData(params?.id);
		}

		if (location.state?.reportName) {
			return { processName: location.state.reportName };
		}

		return {};
	}, [location.state?.reportName, params?.id]);

	return { state };
}

export default useGetStateFromParams;
